import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_CONFIG,
    responseType: 'json'
});

instance.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        return Promise.reject(error);
    }
);

const { get, post, put, delete: destroy, patch } = instance;
export { get, patch, post, put, destroy };
